import { render, staticRenderFns } from "./ServiceChange.vue?vue&type=template&id=2fab2e3e&scoped=true&"
import script from "./ServiceChange.vue?vue&type=script&lang=js&"
export * from "./ServiceChange.vue?vue&type=script&lang=js&"
import style0 from "./ServiceChange.vue?vue&type=style&index=0&id=2fab2e3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fab2e3e",
  null
  
)

export default component.exports